<!-- TODO: erp project id, only in XLS -->
<!-- TODO: ext confirmation number, only in XLS -->
<!-- TODO: PTA flag, only in XLS -->

<template>
	<div>
		<v-progress-linear
			indeterminate
			color="primary"
			height="3"
			v-show="loadingData"
		></v-progress-linear>
		<v-card>
			<v-data-table
				class="table"
				:items="revenueItems"
				:items-per-page="100"
				:headers="computedHeaders"
				hide-default-footer
				fix-header
				item-key="row_identifier"
				no-data-text="There is no data to this filters."
				:single-expand="true"
				:expanded.sync="expanded"
				show-expand:search="search"
				@click:row="clicked"
				:options.sync="options"
			>
				<!-- order date -->
				<template v-slot:item.order_date="{ item }" class="infoColumn">
						{{ item.order_date }}
				</template>
				<!-- increment id = order id -->
				<template
					v-slot:item.increment_id="{ item }"
					v-if="showColumn('increment_id')"
				>
					{{ item.increment_id }}
				</template>
				<!-- mandator -->
				<template v-slot:item.mandator="{ item }"
					class="infoColumn"
					v-if="hideMandatorName('mandator')"
				>
					{{ item.mandator }}
				</template>
				<!-- product name -->
				<template v-slot:item.product_name="{ item }" class="infoColumn">
					{{ item.product_name }}
				</template>
				<!-- validity start date -->
				<template
					v-slot:item.validity_start_date="{ item }"
					v-if="showColumn('validity_start_date')"
				>
					{{ item.validity_start_date }}
				</template>
				<!-- serviceprovider name -->
				<template v-slot:item.serviceprovider_name="{ item }" class="infoColumn">
					{{ item.serviceprovider_name }}
				</template>
				<!-- website = "channel" -->
				<template
					v-slot:item.website_name="{ item }"
					v-if="columnVisible('website_name')"
				>
					{{ item.website_name }}
				</template>
				<!-- store name (german, english, etc.) -->
				<template
					v-slot:item.store_name="{ item }"
					v-if="showColumn('store_name')"
				>
					{{ item.store_name }}
				</template>
				<!-- reseller name -->
				<template
					text-align: right !important
					v-slot:item.reseller_name="{ item }"
					v-if="showColumn('reseller_name')"
				>
					{{ item.reseller_name }}
				</template>
				<!-- order type (booking /refund) -->
				<template v-slot:item.order_refunded_flag="{ item }">
					{{ item.order_refunded_flag | bookedOrStorno }}
				</template>
				<!-- payment_method -->
				<template
					v-slot:item.payment_method="{ item }"
					v-if="showColumn('payment_method')"
				>
					{{ item.payment_method }}
					{{ item.payment_cc_type | paymentDisplay }}
				</template>
				<!-- TODO: payment transaction id, only in XLS-->
				<!-- TODO: erp project id, only in XLS -->
				<!-- TODO: ext confirmation number, only in XLS -->
				<!-- TODO: PTA flag, only in XLS -->
				<!-- Quantity -->
				<template v-slot:item.quantity="{ item }" class="infoColumn">
					<v-chip :color="getColor(item.quantity)" dark
						>{{ item.quantity | toDecimal }}
					</v-chip>
				</template>
				<!-- unit price -->
				<!-- price -->
				<!-- discount -->
				<!-- TODO: coupon code, only in XLS -->
				<!-- total gross -->
				<!-- tax in % -->
				<!-- tax amount -->
				<!-- total net -->
				<!-- serviceprovider comm in % -->
				<template
					v-slot:item.serviceprovider_comission="{ item }" class="infoColumn"
				>
					{{ item.serviceprovider_comission | toDecimal }} %
				</template>
				<!-- serviceprovider comm net -->
				<template
					v-slot:item.serviceprovider_commission_net="{ item }" class="infoColumn"
				>
					{{ item.serviceprovider_commission_net,
						currencyFormat.locale,
						item.order_currency_code | toCurrency }}
				</template>
				<!-- reseller comm in % -->
				<template
					v-slot:item.reseller_commission_percent="{ item }"
					v-if="showColumn('reseller_commission_percent')"
				>
					{{ item.reseller_commission_percent | toDecimal }} %
				</template>
				<!-- reseller comm net -->
				<template
					v-slot:item.reseller_comission_amount="{ item }"
					v-if="showColumn('reseller_comission_amount')"
				>
					{{ item.reseller_comission_amount,
						currencyFormat.locale,
						item.order_currency_code | toCurrency }}
				</template>
				<!-- row_total_excl_discountandcomission -->
				<template
					v-slot:item.row_total_excl_discountandcomission="{ item }"
					class="infoColumn"
				>
					<v-chip
						:color="getColor(item.row_total_excl_discountandcomission)"
						dark
						>{{
							item.row_total_excl_discountandcomission,
							currencyFormat.locale,
							item.order_currency_code | toCurrency
						}}</v-chip
					>
				</template>
				<template v-slot:item.row_total_incl_tax="{ item }" class="infoColumn">
					{{ item.row_total_incl_tax,
						currencyFormat.locale,
						item.order_currency_code | toCurrency }}
				</template>
				<template v-slot:item.unit_price_incl_tax="{ item }" class="infoColumn">
					{{ item.unit_price_incl_tax,
						currencyFormat.locale,
						item.order_currency_code | toCurrency}}
				</template>
				<template v-slot:item.discount_amount="{ item }" class="infoColumn">
					{{ item.discount_amount,
						currencyFormat.locale,
						item.order_currency_code | toCurrency }}
				</template>
				<template v-slot:item.tax_percent="{ item }" class="infoColumn">
					{{ item.tax_percent | toDecimal }} %
				</template>
				<template v-slot:item.tax_amount="{ item }" class="infoColumn">
					{{ item.tax_amount,
						currencyFormat.locale,
						item.order_currency_code | toCurrency }}
				</template>
				<template v-slot:item.row_total_excl_tax="{ item }" class="infoColumn">
					{{ item.row_total_excl_tax,
						currencyFormat.locale,
						item.order_currency_code | toCurrency }}
				</template>
				<template
					v-slot:item.reseller_comission_amount="{ item }"
					class="infoColumn"
				>
					{{ item.reseller_comission_amount,
						currencyFormat.locale,
						item.order_currency_code | toCurrency }}
				</template>

				<template
					v-slot:item.row_total_excl_discount="{ item }"
					class="infoColumn"
				>
					<v-chip :color="getColor(item.row_total_excl_discount)" dark>{{
						item.row_total_excl_discount,
						currencyFormat.locale,
						item.order_currency_code | toCurrency
					}}</v-chip>
				</template>

				<template v-if="showColumnBillingEngine('billingengine_order')" v-slot:item.billingengine_order="{ item }">
					{{ item.billingengine_order | boolenToYesNo }}
				</template>

				<template v-slot:expanded-item="current">
					<td :colspan="headers.length + 1" class="detailInfo">
						<revenue-detail-info
							:detailRowsInfoAndData="detailRowsInfoAndData"
							:loadingDetailData="loadingDetailData"
							:currencyFormat="currencyFormat"
							:showDetailTable="showDetailTable"
							:billingEngineActivated="billingEngineActivated"
						/>
					</td>
				</template>
			</v-data-table>
		</v-card>
		<v-btn
			v-scroll="onScroll"
			v-show="scrollUpBtnShow"
			scrollUpBtnShow
			dark
			fixed
			bottom
			right
			color="dark"
			@click="toTop"
		>
			<v-icon>mdi-arrow-up-bold-circle</v-icon>
		</v-btn>
		<v-layout wrap>
			<v-flex class="pagination">
				<v-progress-linear
					indeterminate
					color="primary"
					height="3"
					v-show="loadingData"
				></v-progress-linear>
				<v-pagination
					:key="paginationKey"
					v-model="pagination.page"
					:length="pagination.pages"
					@input="next"
					v-show="pagination.showBottomPagination"
					:total-visible="pagination.totalVisible"
					circle
				></v-pagination>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import axios from 'axios'
import RevenueDetailInfo from './RevenueDetailInfo.vue'

export default {
	name: 'reportingsystemTable',
	components: {
		RevenueDetailInfo,
	},
	props: [
		'revenueItems',
		'selectedFilters',
		'pagination',
		'currencyFormat',
		'loadingData',
		'paginationKey',
		'billingEngineActivated',
	],
	data() {
		return {
			headers: [
				{
					text: 'Order date',
					value: 'order_date',
					selected: true,
					sortable: true,
				},
				{
					text: 'Order ID',
					value: 'increment_id',
					hide: 'mdAndDown',
					selected: false,
					sortable: true,
				},
				{
					text: 'Mandator',
					value: 'mandator',
					name: 'mandator',
					hide: 'mdAndDown',
					selected: false,
					sortable: true,
				},
				{
					text: 'Product name',
					value: 'product_name',
					name: 'product_name',
					hide: 'mdAndDown',
					selected: true,
					sortable: true,
				},
				{
					text: 'SKU',
					value: 'product_sku',
					name: 'product_sku',
					selected: true,
					sortable: true,
				},
				{
					text: 'Validity start date',
					value: 'validity_start_date',
					name: 'validity_start_date',
					hide: 'mdAndDown',
					selected: false,
					sortable: true,
				},
				{
					text: 'Serviceprovider',
					value: 'serviceprovider_name',
					name: 'serviceprovider_name',
					hide: 'mdAndDown',
					selected: true,
					sortable: true,
				},
				{
					text: 'Channel',
					value: 'website_name',
					name: 'website_name',
					hide: 'mdAndDown',
					selected: true,
					sortable: true,
				},
				{
					text: 'Store',
					value: 'store_name',
					name: 'store_name',
					hide: 'mdAndDown',
					selected: false,
					sortable: true,
				},
				{
					text: 'Reseller',
					value: 'reseller_name',
					hide: 'mdAndDown',
					selected: true,
					sortable: true,
				},
				{
					text: 'Order-Type',
					value: 'order_refunded_flag',
					hide: 'mdAndDown',
					selected: true,
					sortable: true,
				},
				{
					text: 'Payment',
					value: 'payment_method',
					hide: 'mdAndDown',
					selected: true,
					sortable: true,
				},
				{
					text: 'Qty.',
					value: 'quantity',
					selected: true,
					sortable: true,
					align: 'right',
				},
				{
					text: 'Unit price AVG',
					value: 'unit_price_incl_tax',
					hide: 'mdAndDown',
					selected: true,
					sortable: true,
					align: 'right',
				},
				{
					text: 'Price',
					value: 'row_total_incl_tax',
					hide: 'mdAndDown',
					selected: true,
					sortable: true,
					align: 'right',
				},
				{
					text: 'Discount',
					value: 'discount_amount',
					hide: 'mdAndDown',
					selected: true,
					sortable: true,
					align: 'right',
				},
				{
					text: 'Total gross',
					value: 'row_total_excl_discount',
					selected: true,
					sortable: false,
					align: 'right',
				},
				{
					text: 'Tax in %',
					value: 'tax_percent',
					hide: 'mdAndDown',
					selected: true,
					sortable: true,
					align: 'right',
				},
				{
					text: 'Tax amount',
					value: 'tax_amount',
					hide: 'mdAndDown',
					selected: true,
					sortable: true,
					align: 'right',
				},
				{
					text: 'Total Net',
					value: 'row_total_excl_tax',
					hide: 'mdAndDown',
					selected: true,
					sortable: true,
					align: 'right',
				},
				{
					text: 'SP. Comm. in %',
					value: 'serviceprovider_comission',
					name: 'serviceprovider_comission',
					hide: 'mdAndDown',
					selected: true,
					sortable: true,
				},
				{
					text: 'SP. Comm. Net',
					value: 'serviceprovider_commission_net',
					name: 'serviceprovider_commission_net',
					hide: 'mdAndDown',
					selected: true,
					sortable: true,
				},
				{
					text: 'Reseller Comm. in %',
					value: 'reseller_commission_percent',
					hide: 'mdAndDown',
					selected: false,
					sortable: true,
					align: 'right',
				},
				{
					text: 'Reseller Comm. Gross',
					value: 'reseller_comission_amount',
					hide: 'mdAndDown',
					selected: true,
					sortable: true,
					align: 'right',
				},
				{
					text: 'Billing engine order',
					value: 'billingengine_order',
					hide: 'billingEngine',
					selected: true,
					sortable: true,
					align: 'right',
				},
			],
			scrollUpBtnShow: false,
			expanded: [],
			loadingDetailData: false,
			bookingRowsDetail: [],
			detailRowsLength: Number,
			detailRowsInfoAndData: {},
			showDetailTable: false,
			options: {
				page: 1,
				itemsPerPage: 50,
				sortBy: ['order_date'],
				sortDesc: [false],
				groupBy: [],
				groupDesc: [],
				mustSort: false,
				multiSort: false,
			},
		}
	},
	watch: {
		expanded: {
			async handler() {
				const expandedRow = await this.expanded[0]
				this.getRowdetail(expandedRow).catch() // this is not an error on catch
			},
		},
		options: {
			handler() {
				const selectedFiltersAndPagination = {
					filterOptions: this.selectedFilters,
					pagination: this.pagination,
				}
				selectedFiltersAndPagination.pagination.sortBy = this.options.sortBy
				selectedFiltersAndPagination.pagination.sortDesc = this.options.sortDesc
				this.$emit('sortHasChanged', selectedFiltersAndPagination)
			},
		},
	},
	methods: {
		hideMandatorName(col) {
			if (this.selectedFilters.mandators && this.selectedFilters.mandators.length !== 1) {
				// eslint-disable-next-line no-return-assign
				return this.headers.find((h) => h.value === col).selected = true
			}
			// eslint-disable-next-line no-return-assign
			return this.headers.find((h) => h.value === col).selected = false
		},
		refreshFilters() {
			this.filteredServiceproviders = this.selectedFilters.serviceprovider
		},
		columnVisible(value) {
			const columns = this.headers.filter((o) => o.value == value)
			if (columns.length == 0) return true

			const column = columns[0]
			return this.$vuetify.breakpoint[column.hide]
		},
		showColumn(col) {
			if (this.selectedFilters.grouping === 'Ungrouped') {
				return this.headers.find((h) => h.value === col).selected = true
			}
			return this.headers.find((h) => h.value === col).selected = false
		},
		showColumnBillingEngine(col) {
			if (this.billingEngineActivated && this.selectedFilters.grouping === 'Ungrouped') {
				return this.headers.find((h) => h.value === col).selected = true
			}
			return this.headers.find((h) => h.value === col).selected = false
		},
		onScroll(e) {
			if (typeof window === 'undefined') return
			const top = window.pageYOffset || e.target.scrollTop || 0
			this.scrollUpBtnShow = top > 20
		},
		toTop() {
			this.$vuetify.goTo(0)
		},
		next() {
			const selectedFiltersAndPagination = {
				filterData: this.selectedFilters,
				pagination: this.pagination,
			}
			this.$emit('next', selectedFiltersAndPagination)
		},
		getColor(value) {
			if (value > 0) return 'green'
			if (value < 0) return 'red'
			return 'orange'
		},
		async clicked(value) {
			if (this.selectedFilters.grouping != 'Ungrouped') {
				this.expanded.push(value)
				if (Number(this.expanded[0].quantity) < 100) {
					if (this.expanded[0] === this.expanded[1]) {
						this.expanded = []
					} else {
						this.expanded = []
						this.expanded.push(value)
					}
				}
				console.log(this.expanded)
			}
		},
		async getRowdetail(expandedRow) {
			if (expandedRow && this.selectedFilters.grouping != 'Ungrouped') {
				if (Math.abs(Number(this.expanded[0].quantity)) < 100) {
					this.loadingDetailData = true
					this.showDetailTable = false
					// arguments order:
					// order_date | product_sku | product_subcategory |
					// serviceprovider_id | website_id | website_name |
					// order_refunded_flag | payment_method | tax_percent | dateFrom | dateTill
					let rowArguments = []
					rowArguments = await expandedRow.row_identifier.split('?')
					rowArguments.push(
						this.selectedFilters.dateFrom,
						this.selectedFilters.dateTill,
						this.selectedFilters.switchOrderValidityDate,
					)
					// eslint-disable-next-line max-len, no-undef
					const r = await axios.post(`${config.baseAPIurl}/revenue-report/row-detail`, { rowdetail: rowArguments })
					this.detailRowsInfoAndData = {
						detailRowsLength: r.data.length,
						bookingRowsDetail: r.data,
					}
					this.loadingDetailData = false
					this.showDetailTable = true
				} else {
					this.expanded = []
					this.$emit('tooManyRows')
				}
			} else {
				throw new Error()
			}
		},
	},
	computed: {
		computedHeaders() {
			const filterdHeaders = []
			this.headers.forEach((header) => {
				if ((!header.hide || !this.$vuetify.breakpoint[header.hide]) && header.selected) {
					filterdHeaders.push(header)
				}
			})
			return filterdHeaders
		},
	},
	filters: {
		toCurrency(amount, locale, currency) {
			const number = Number(amount)
			const formatter = new Intl.NumberFormat(locale, {
				style: 'currency',
				currency,
				minimumFractionDigits: 2,
			})
			return formatter.format(number)
		},
		toDecimal(value) {
			const number = Number(value)
			const result = number.toFixed(2)
			return result
		},
		toDate(value) {
			const date = new Date(value)
			return date.toUTCString()
		},
		bookedOrStorno(value) {
			if (value === false) {
				return 'Booking'
			}
			return 'Refund'
		},
		rowTotalExclComission(rowTotal, comission) {
			const rowTotalNum = Number(rowTotal)
			const comissionNum = Number(comission)
			return (rowTotalNum - comissionNum).toFixed(2)
		},
		paymentDisplay(creditCard) {
			let concattedCreditCard = ''
			if (creditCard != null) {
				concattedCreditCard = concattedCreditCard.concat(' - ', creditCard)
			}
			return concattedCreditCard
		},
		boolenToYesNo(value) {
			if (value === null || typeof (value) == 'undefined') return 'info not available'
			return value ? 'Yes' : 'No'
		},
	},
	updated() {
		this.refreshFilters()
	},
}
</script>

<style>
td {
	font-family: Roboto, sans-serif, sans;
}

.columnWide {
	min-width: 300px;
}

tr {
	white-space: nowrap;
	padding: 14px;
}

.infoColumn {
	text-align: right !important;
}

.greyColumn {
	background-color: rgba(128, 128, 128, 0.15);
}

.totalColumn {
	background-color: rgba(9, 140, 9, 0.2);
	text-align: right;
}

.valueMinusColor {
	background-color: rgba(255, 0, 0, 0.15);
	text-align: right;
}

.table {
	border-collapse: collapse;
	border-spacing: 0;
	width: 100%;
}

.table th {
	text-transform: uppercase;
}

table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
	padding: 0 4px !important;
}

table.v-table tbody td,
table.v-table tbody th {
	height: 32px;
}

.grid-list-xl {
	padding: 0 !important;
}

.detailInfo {
	background-color: rgba(128, 128, 128, 0.2);
	padding: unset;
}

.detailInfo .v-datatable thead th.column.sortable {
	background-color: rgba(128, 128, 128, 0.2);
	text-align: right;
}

.infoColumnDetail {
	background-color: rgba(128, 128, 128, 0.3);
	text-align: right;
}

.infoColumnDetailLeft {
	background-color: rgba(128, 128, 128, 0.3);
	text-align: left;
}

.pagination {
	padding: 25px;
}

</style>
